module.exports = __webpack_public_path__ + "static/media/AoA_CloseUp_21.d4439b27.jpg";